import * as $ from 'jquery';
$(document).ready(function(){
    $('.tab').click(function(){
        $('.tab').removeClass('active-tab');
        $(this).addClass('active-tab');
        var tagid = $(this).data('tag');
        $('.tab_item').removeClass('active').addClass('hide');
        $('#'+tagid).addClass('active').removeClass('hide');
    });
});